import type { NodeVariable } from "../../types";
import { FileVariableSelector } from "./file-variable-selector";
import { useMemo } from "react";

interface AttachmentInputProps {
  variables: NodeVariable[];
  selectedAttachments: string[];
  onChange: (attachmentIds: string[]) => void;
}

/**
 * Componente para seleccionar múltiples archivos adjuntos
 * Muestra un selector con checkboxes para variables de tipo file
 */
export const AttachmentInput: React.FC<AttachmentInputProps> = ({
  variables,
  selectedAttachments,
  onChange,
}) => {
  // Filtrar solo variables de tipo file
  const fileVariables = useMemo(() => {
    return variables
      .map((nodeVar) => ({
        ...nodeVar,
        //variables: nodeVar.variables.filter((v) => v.type === "file"),
        variables: nodeVar.variables,
      }))
      .filter((nodeVar) => nodeVar.variables.length > 0);
  }, [variables]);

  return (
    <FileVariableSelector
      variables={fileVariables}
      selectedValues={selectedAttachments}
      onChange={onChange}
    />
  );
};
